import { useBuildVars } from '../build-config';
import useIM360Origin from './useIM360Origin';
import { FRAME_ID } from './utils';

export function usePostToX4A() {
  const { X4A_ORIGIN } = useBuildVars();
  const IM360_ORIGIN = useIM360Origin();
  const postMessageToX4A = (
    action: string,
    payload?: { [key: string]: any },
    isIM360 = false
  ) => {
    window.parent.postMessage(
      {
        action,
        frameId: FRAME_ID,
        ...payload,
      },
      isIM360 ? IM360_ORIGIN : X4A_ORIGIN
    );
  };
  /** Updates the reseller context in X4A by calling impersonation API with the specified BCN. */
  const updateImpersonatedReseller = (resellerId: string) => {
    postMessageToX4A('impersonate-reseller', { resellerId });
  };

  /** Ends impersonation of the current reseller in X4A. */
  const disableImpersonation = () => {
    postMessageToX4A('disable-impersonation');
  };

  /** Re-renders the X4C iframe with the newly specified path. */
  const updateX4CFramePath = (newPath: string, isInIM360Frame = false) => {
    postMessageToX4A('update-frame-path', { newPath }, isInIM360Frame);
  };

  /** Navigates X4C app to the specified route or route. Open in new tab is false by default. */
  const navigateToInX4A = (navOptions: {
    countryCode?: string;
    openInNewTab?: boolean;
    url?: string;
    x4aRoute?: string;
  }) => {
    postMessageToX4A('navigate-x4a-to', { navOptions });
  };

  return {
    disableImpersonation,
    navigateToInX4A,
    postMessageToX4A,
    updateImpersonatedReseller,
    updateX4CFramePath,
  };
}
